var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-detailed-sub-header',{attrs:{"breadcrumbs":_vm.breadcrumbs,"label-name":_vm.member.name || _vm.member.email}},[_c('member-role-tag',{attrs:{"slot":"tags","dark":"","role":_vm.member.role},slot:"tags"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }